// extracted by mini-css-extract-plugin
export var aiStarIcon = "_c1-4";
export var closeButton = "_c1-6";
export var dismissButton = "_c1-3";
export var editImageWithAiContainer = "_c1-8";
export var imageUploadWrapper = "_c1-7";
export var misspelledWord = "_c1-5";
export var spellCheckContainer = "_c1-2";
export var spin = "_c1-1";
export var spinning = "_c1-0";